import { db } from './index'
import {
  collection,
  addDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  doc,
  query,
  orderBy,
  serverTimestamp
} from 'firebase/firestore'

/**
 * 미디어(이벤트/당첨자/홍보영상/언론보도) 공용 CRUD 서비스
 * type: 'event' | 'winner' | 'video' | 'press'
 */

const COLLECTIONS = {
  event: 'media_events',
  winner: 'media_winners',
  video: 'media_videos',
  press: 'media_press',
  popup: 'media_popups'
}

function getCollectionName(type) {
  if (!COLLECTIONS[type]) throw new Error(`Invalid media type: ${type}`)
  return COLLECTIONS[type]
}

/**
 * 목록 조회 (최신순)
 */
export async function listMedia(type) {
  const q = query(
    collection(db, getCollectionName(type)),
    orderBy('createdAt', 'desc')
  )
  const snap = await getDocs(q)
  return snap.docs.map(d => ({ id: d.id, ...d.data() }))
}

/**
 * 신규 등록
 */
export async function addMedia(type, data) {
  const docRef = await addDoc(collection(db, getCollectionName(type)), {
    ...data,
    createdAt: serverTimestamp()
  })
  return docRef.id
}

/**
 * 수정
 */
export async function updateMedia(type, id, data) {
  await updateDoc(doc(db, getCollectionName(type), id), {
    ...data,
    updatedAt: serverTimestamp()
  })
}

/**
 * 삭제
 */
export async function deleteMedia(type, id) {
  await deleteDoc(doc(db, getCollectionName(type), id))
}
